import { parseUrl, stringify } from 'query-string';

export default function cacheBustUrl(urlString = '') {
  if (urlString.startsWith('data') || urlString.startsWith('file')) {
    // do not cache bust data URI
    return urlString;
  }

  const { url, query } = parseUrl(urlString);
  query.timestamp_ms = Date.now();
  return `${url}?${stringify(query)}`;
}
